import React from 'react';
import { Container } from 'reactstrap';

import { useSelector } from 'react-redux';
import {
  isAdmin as isAdminSelector,
  isManager as isManagerSelector,
  isTeamLeader as isTeamLeaderSelector,
  isPublisher as isPublisherSelector,
  isCallAnalyst as isCallAnalystSelector,
} from '../../selectors/auth';
import AdminLeads from './admin';
import PublisherLeads from './publisher';
import CallAnalystLeads from './callAnalyst';

const List = (props) => {
  const isAdmin = useSelector(isAdminSelector);
  const isManager = useSelector(isManagerSelector);
  const isTeamLeader = useSelector(isTeamLeaderSelector);
  const isPublisher = useSelector(isPublisherSelector);
  const isCallAnalyst = useSelector(isCallAnalystSelector);
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          {(isAdmin || isManager || isTeamLeader) && <AdminLeads />}
          {isPublisher && <PublisherLeads />}
          {isCallAnalyst && <CallAnalystLeads />}
        </Container>
      </div>
    </React.Fragment>
  );
};

export default List;
